export default __webpack_public_path__ + "static/media/category_24.94fd311c.png";